import {
  fetchOrganizationDetails,
  updateOrganization,
} from "./organizations.service";

export const organizationsService = {
  fetchOrganizationDetails,
  updateOrganization,
};
